module.exports = __webpack_public_path__ + "media/images/icon__breadcrumbs-arrow-left--rb-raven-gray@2x-3c138d7ffce4d82988274fa156e6b29b.png";